import { LocalCatalogueBrowser } from '@/components/catalogue/LocalCatalogueBrowser'
export function LocalCataloguePage() { return <LocalCatalogueBrowser /> }
